import React, { useEffect, useState } from "react";
import AddHeaderButton from "./components/Modals/AddHeaderButton";
import { useAppServices } from "../../../../hook/services";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

const HeaderButtons = () => {
  const AppService = useAppServices();
  const { companyId, type, customizationId } = useParams();
  const [headerButtons, setHeaderButtons] = useState([]);
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [deletingIndex, setDeletingIndex] = useState(null);

  const handler =
    type === "agency" || type === "location"
      ? AppService.sidenav_customizer_main_level
      : type === "group"
      ? AppService.sidenav_customizer_custom_level
      : AppService.sidenav_customizer_saas_level;

  const query =
    type === "location" || type === "agency"
      ? `companyId=${companyId}&type=${type}`
      : `_id=${customizationId}`;

  const getData = async () => {
    setLoading(true);
    try {
      const { response } = await handler.filter({ query });
      if (response?.data) {
        setHeaderButtons(response.data.header_buttons || []);
        setData(response.data);
      } else {
        setHeaderButtons([]);
        setData({});
      }
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const handleDelete = async (editIndex) => {
    if (editIndex === null || editIndex < 0 || !data?._id) {
      toast.error("Invalid delete request.");
      return;
    }

    const header_buttons = data?.header_buttons ? [...data.header_buttons] : [];
    header_buttons.splice(editIndex, 1);

    const payload = {
      header_buttons,
      companyId,
      _id: data._id,
    };

    try {
      setDeletingIndex(editIndex);
      const { response } = await handler.update({ payload });
      if (response) {
        toast.success("Button deleted.");
        getData();
      } else {
        toast.error("Failed to delete the button.");
      }
    } catch (error) {
      console.error("Delete error:", error);
      toast.error("An error occurred while deleting.");
    } finally {
      setDeletingIndex(null);
    }
  };

  return (
    <div className="hb-list-wrapper">
      <style>{`
        .hb-list-wrapper {
          background: #ffffff;
          border-radius: 16px;
          padding: 22px 24px;
          border: 1px solid #e2e8f0;
        }
        .hb-list-header {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          gap: 16px;
          flex-wrap: wrap;
          margin-bottom: 20px;
        }
        .hb-list-title {
          margin: 0;
          font-size: 18px;
          font-weight: 600;
          color: #0f172a;
          display: flex;
          align-items: center;
          gap: 10px;
        }
        .hb-list-title .hb-badge {
          background: #eef2ff;
          color: #4338ca;
          font-size: 12px;
          font-weight: 600;
          border-radius: 999px;
          padding: 2px 10px;
        }
        .hb-list-subtitle {
          color: #64748b;
          font-size: 13px;
          margin: 4px 0 0;
        }
        .hb-empty {
          border: 1px dashed #cbd5e1;
          border-radius: 14px;
          padding: 48px 20px;
          text-align: center;
          background: linear-gradient(180deg, #f8fafc 0%, #eef2ff 100%);
        }
        .hb-empty .hb-empty-icon {
          width: 56px;
          height: 56px;
          border-radius: 16px;
          background: #fff;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          color: #4f46e5;
          font-size: 26px;
          box-shadow: 0 8px 24px rgba(79, 70, 229, 0.18);
          margin-bottom: 14px;
        }
        .hb-empty h6 {
          font-size: 15px;
          color: #0f172a;
          font-weight: 600;
          margin: 0 0 4px;
        }
        .hb-empty p {
          color: #64748b;
          font-size: 13px;
          margin: 0 0 14px;
        }
        .hb-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
          gap: 14px;
        }
        .hb-card {
          background: #ffffff;
          border: 1px solid #e2e8f0;
          border-radius: 14px;
          padding: 16px;
          display: flex;
          flex-direction: column;
          gap: 12px;
          transition: border-color 0.15s, box-shadow 0.15s;
        }
        .hb-card:hover {
          border-color: #c7d2fe;
          box-shadow: 0 8px 24px rgba(15, 23, 42, 0.06);
        }
        .hb-card-preview {
          background: linear-gradient(180deg, #f8fafc 0%, #eef2ff 100%);
          border-radius: 10px;
          padding: 18px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .hb-card-btn {
          border: none;
          padding: 8px 16px;
          font-weight: 500;
          font-size: 13px;
          color: #fff;
          display: inline-flex;
          align-items: center;
          gap: 8px;
          box-shadow: 0 4px 12px rgba(15, 23, 42, 0.15);
          cursor: default;
        }
        .hb-card-meta {
          display: flex;
          flex-direction: column;
          gap: 6px;
        }
        .hb-card-meta .hb-card-name {
          font-size: 14px;
          font-weight: 600;
          color: #0f172a;
          margin: 0;
          word-break: break-word;
        }
        .hb-card-meta .hb-card-row {
          font-size: 12px;
          color: #64748b;
          display: flex;
          align-items: center;
          gap: 6px;
          word-break: break-all;
        }
        .hb-card-meta .hb-card-row > span.text-truncate {
          min-width: 0;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .hb-pill {
          display: inline-flex;
          align-items: center;
          gap: 4px;
          font-size: 11px;
          padding: 2px 8px;
          border-radius: 999px;
          font-weight: 500;
          flex-shrink: 0;
        }
        .hb-pill.target { background: #eef2ff; color: #4338ca; }
        .hb-pill.link { background: #ecfeff; color: #0e7490; }
        .hb-pill.icon-only { background: #fdf4ff; color: #a21caf; }
        .hb-card-actions {
          display: flex;
          align-items: center;
          gap: 8px;
          margin-top: 4px;
          padding-top: 12px;
          border-top: 1px solid #f1f5f9;
        }
        .hb-card-actions .hb-action-btn {
          flex: 1;
          border: 1px solid #e2e8f0;
          background: #fff;
          color: #475569;
          border-radius: 8px;
          padding: 6px 10px;
          font-size: 12px;
          font-weight: 500;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          transition: all 0.15s;
        }
        .hb-card-actions .hb-action-btn:hover {
          background: #f8fafc;
          color: #0f172a;
        }
        .hb-card-actions .hb-action-btn.delete {
          color: #b91c1c;
          border-color: #fecaca;
          background: #fef2f2;
        }
        .hb-card-actions .hb-action-btn.delete:hover {
          background: #fee2e2;
          color: #991b1b;
        }
        .hb-card-actions .hb-edit-slot { flex: 1; display: flex; }
        .hb-card-actions .hb-edit-slot > * { width: 100%; }
        .hb-card-actions .hb-edit-slot .btn {
          width: 100%;
          padding: 6px 10px;
          font-size: 12px;
          font-weight: 500;
          gap: 6px;
        }
        .hb-skeleton {
          height: 180px;
          border-radius: 14px;
          background: linear-gradient(90deg, #f1f5f9 0%, #e2e8f0 50%, #f1f5f9 100%);
          background-size: 200% 100%;
          animation: hbSkeleton 1.5s ease-in-out infinite;
        }
        @keyframes hbSkeleton {
          0% { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }
      `}</style>

      <div className="hb-list-header">
        <div>
          <h3 className="hb-list-title">
            <i className="bi bi-window-stack text-primary" />
            Header Buttons
            {!loading && (
              <span className="hb-badge">{headerButtons.length}</span>
            )}
          </h3>
          <p className="hb-list-subtitle">
            Buttons that appear in the GHL top navigation header.
          </p>
        </div>
        {!loading && <AddHeaderButton data={data} handleRefresh={getData} />}
      </div>

      {loading ? (
        <div className="hb-grid">
          <div className="hb-skeleton" />
          <div className="hb-skeleton" />
          <div className="hb-skeleton" />
        </div>
      ) : headerButtons.length === 0 ? (
        <div className="hb-empty">
          <div className="hb-empty-icon">
            <i className="bi bi-window-stack" />
          </div>
          <h6>No header buttons yet</h6>
          <p>
            Add a button to give your team a one-click action right from the
            GHL header bar.
          </p>
          <AddHeaderButton data={data} handleRefresh={getData} />
        </div>
      ) : (
        <div className="hb-grid">
          {headerButtons.map((item, index) => {
            const isLink = item.action_type === "Link";
            const previewBorderRadius =
              item.onlyIcon || !item.button_text ? "50%" : "8px";
            const previewSize = item.onlyIcon ? "36px" : "auto";
            return (
              <div className="hb-card" key={index}>
                <div className="hb-card-preview">
                  <span
                    className="hb-card-btn"
                    style={{
                      background: item.color || "#4f46e5",
                      borderRadius: previewBorderRadius,
                      width: previewSize,
                      height: previewSize,
                      padding: item.onlyIcon ? 0 : "8px 16px",
                      justifyContent: "center",
                    }}
                    title={item.tooltip || item.button_text}
                  >
                    {item.icon && (
                      <i
                        className={`${item.iconFamily || "fas"} fa-${item.icon}`}
                        style={{ fontSize: 13 }}
                      />
                    )}
                    {!item.onlyIcon && <span>{item.button_text}</span>}
                  </span>
                </div>

                <div className="hb-card-meta">
                  <p
                    className="hb-card-name"
                    title={item.button_text || item.tooltip}
                  >
                    {item.button_text || (
                      <span className="text-muted fst-italic">
                        Icon-only button
                      </span>
                    )}
                  </p>
                  {isLink && item.link && (
                    <div className="hb-card-row">
                      <span className="hb-pill link">
                        <i className="bi bi-link-45deg" />
                        Link
                      </span>
                      <span className="text-truncate" title={item.link}>
                        {item.link}
                      </span>
                    </div>
                  )}
                  {!isLink && item.targetLocation && (
                    <div className="hb-card-row">
                      <span className="hb-pill target">
                        <i className="bi bi-bullseye" />
                        Target
                      </span>
                      <span
                        className="text-truncate"
                        title={item.targetLocation}
                      >
                        {item.targetLocation}
                      </span>
                    </div>
                  )}
                  {item.onlyIcon && (
                    <div className="hb-card-row">
                      <span className="hb-pill icon-only">
                        <i className="bi bi-emoji-smile" />
                        Icon only
                      </span>
                    </div>
                  )}
                </div>

                <div className="hb-card-actions">
                  <div className="hb-edit-slot">
                    <AddHeaderButton
                      data={data}
                      handleRefresh={getData}
                      selectedButton={item}
                      editIndex={index}
                    />
                  </div>
                  <button
                    className="hb-action-btn delete"
                    title="Delete"
                    onClick={() => handleDelete(index)}
                    disabled={deletingIndex === index}
                  >
                    {deletingIndex === index ? (
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      <>
                        <i className="bi bi-trash" />
                        Delete
                      </>
                    )}
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default HeaderButtons;
